<header
  *ngIf="!showNavBar"
  class="padding-top-bottom-15 bg-light-2"
  [ngClass]="{'header-christmas-wt': globalSrv.itsCristhmasHolidays() && sys === 'wt' , 
                    'header-christmas-ltk': globalSrv.itsCristhmasHolidays() && sys === 'ltk'}"
>
  <div class="content-wrap txt-center v-center full-height">
    <h1 class="absolute top-0 left-0 ldg-logo-txt block">
      <ng-container *ngIf="sys === 'wt'">
        <ng-container *ngIf="('lang' | translate) === 'en'"> Wintrillions.com </ng-container>
        <ng-container *ngIf="('lang' | translate) === 'es'"> Trillonario.com </ng-container>
        <ng-container *ngIf="('lang' | translate)  === 'pt'"> Trilhardario.com </ng-container>
      </ng-container>
      <ng-container *ngIf="sys === 'ltk'">
        <ng-container *ngIf="('lang' | translate) != 'pt'"> Lottokings.com </ng-container>
        <ng-container *ngIf="('lang' | translate)  === 'pt'"> LottoSena.com </ng-container>
      </ng-container>
    </h1>
    <ng-container *ngIf="sys === 'wt'">
      <ng-container *ngIf="('lang' | translate) === 'en'">
        <ng-container *ngIf="globalSrv.itsCristhmasHolidays(); else normal">
          <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/en/logo-christmas.png'" alt="logo" />
        </ng-container>
        <ng-template #normal>
          <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/en/logo.png'" alt="logo" />
        </ng-template>
      </ng-container>
      <ng-container *ngIf="('lang' | translate) === 'es'">
        <ng-container *ngIf="globalSrv.itsCristhmasHolidays(); else normal">
          <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/es/logo-christmas.png'" alt="logo" />
        </ng-container>
        <ng-template #normal>
          <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/es/logo.png'" alt="logo" />
        </ng-template>
        <!-- <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/es/logo.png'" alt="logo" /> -->
      </ng-container>
      <ng-container *ngIf="('lang' | translate) === 'pt'">
        <ng-container *ngIf="globalSrv.itsCristhmasHolidays(); else normal">
          <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/pt/logo-christmas.png'" alt="logo" />
        </ng-container>
        <ng-template #normal>
          <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/pt/logo.png'" alt="logo" />
        </ng-template>
        <!-- <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/pt/logo.png'" alt="logo" /> -->
      </ng-container>
    </ng-container>
    <ng-container *ngIf="sys === 'ltk'">
      <ng-container *ngIf="('lang' | translate) != 'pt'">
        <ng-container *ngIf="globalSrv.itsCristhmasHolidays(); else normal">
          <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/default/logo-christmas.png'" alt="logo" />
        </ng-container>
        <ng-template #normal>
          <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/default/logo.png'" alt="logo" />
        </ng-template>
        <!-- <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/default/logo.png'" alt="logo" /> -->
      </ng-container>
      <ng-container *ngIf="('lang' | translate)  === 'pt'">
        <ng-container *ngIf="globalSrv.itsCristhmasHolidays(); else normal">
          <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/pt/logo-christmas-lotosena.png'" alt="logo" />
        </ng-container>
        <ng-template #normal>
          <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/pt/logo.png'" alt="logo" />
        </ng-template>
        <!-- <img class="logo-img" [attr.src]="'https://d3tmfelegj51yl.cloudfront.net/brand/'+sys+'/pt/logo.png'" alt="logo" /> -->
      </ng-container>
    </ng-container>
  </div>
</header>
